import * as actions from './actions';
import { getInitiatedTime } from '../../utils/actionTiming';
import { getNextAction } from '../../utils/nextActionUtil';
import { isPortrait } from '../../utils/size';

const getApiRequestData = (action, state) => {
    if (action == null || state == null) return null;
    return {
        id: action.id,
        actionId: action.actionId,
        widgetCardId: action.widgetCardId,
        articleId: state.articleId,
        articleUrl: state.articleUrl,
        widgetId: state.widgetId,
        partner: action.partner ? action.partner.name : null,
        partnerId: action.partner ? action.partner.id : null,
        publisherId: state.publisherId,
        publishedDate: state.publishedDate,
        widgetType: state.widgetType,
        widgetEmbedType: state.embedType,
        issueId: action.issue ? action.issue.id : null,
        subIssueId: action.subIssue ? action.subIssue.id : null,
        selectedMultiActionPartner: null,
        actionOrder: action.order,
        location: state.endUserLocation,
        sponsored: state.isSponsored
    };
};

const partnerFromState = (state, actionIdentifier, isFrontCard) => {
    const action = state.actions.find(a => a.identifier === actionIdentifier) || {};
    const card = state.cards[(action.order || 1) - 1] || {};
    let partner = isFrontCard ? card.partner : null;
    if (!partner && action.partner) {
        if (isFrontCard) {
            const partnersOnCard = card.actions.map(a => (a.partner || {}).name);
            if (partnersOnCard.every(p => p === (action.partner || {}).name)) {
                partner = action.partner;
            }
        } else {
            partner = action.partner;
        }
    }
    return partner;
};

const defaultState = state => {
    if (state == null || state.actions == null) return {};

    let newState = {
        ...state,
        addressValidationError: state.addressValidationError
            ? state.addressValidationError
            : false,
        isMobile:
            typeof navigator !== 'undefined'
                ? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                      navigator.userAgent
                  )
                : false,
        isNextActionPaused: false,
        showLocalRep: true,
        activeAction:
            state.activeAction != null
                ? state.activeAction
                : state.actions != null && state.actions.length
                ? state.actions[0]
                : null
    };

    const nextAction = getNextAction(
        newState.actions,
        newState.activeAction.identifier,
        [],
        newState.cards
    );
    newState = {
        ...newState,
        confirmationInfo: {
            hasNextAction: !!nextAction,
            pictureLink: newState.activeAction.endCardPictureLink || null,
            pictureId: newState.activeAction.endCardPictureId || null,
            hideBorders: newState.activeAction.hideEndCardBorders || false,
            text: newState.activeAction.thankYouText || null,
            title: newState.activeAction.thankYouTitle || null,
            useLocalRepresentative: !!newState.activeAction.representativeSearch,
            oldAction: newState.activeAction,
            newAction: nextAction
        },
        apiRequestData: getApiRequestData(newState.activeAction, newState),
        isMobileResolution: isPortrait(),
        isOverlayVisible: state.isOverlayVisible != null ? state.isOverlayVisible : false,
        isOverlayPublisherVisible:
            state.isOverlayPublisherVisible != null
                ? state.isOverlayPublisherVisible
                : false,
        isOverlayPartnerVisible:
            state.isOverlayPartnerVisible != null ? state.isOverlayPartnerVisible : false,
        shareDrawerVisibility:
            state.shareDrawerVisibility != null ? state.shareDrawerVisibility : false,
        textCopiedToClipboard:
            state.textCopiedToClipboard != null ? state.textCopiedToClipboard : false,
        noCardsVisited: state.noCardsVisited != null ? state.noCardsVisited : 1,
        selectedPartner:
            newState.selectedPartner === undefined
                ? partnerFromState(newState, newState.activeAction.identifier, true)
                : newState.selectedPartner
    };

    return newState;
};

function getTimeFrom(fromDate) {
    return (new Date() - fromDate) / 1000;
}

export default function widget(state, { type, payload }) {
    switch (type) {
        case actions.ADDRESS_VALIDATION_ERROR:
            return { ...state, addressValidationError: payload };
        case actions.IS_BACK_TRANSITION:
            return { ...state, isBackTransition: payload };
        case actions.SET_END_USER_ID:
            return { ...state, endUserId: payload };
        case actions.ACTION_SHARED:
            return { ...state, lastSharedWith: payload };
        case actions.OVERLAY_VISIBLE:
            return { ...state, isOverlayVisible: payload };
        case actions.OVERLAY_PUBLISHER_VISIBLE:
            return { ...state, isOverlayPublisherVisible: payload };
        case actions.OVERLAY_PARTNER_VISIBLE:
            return { ...state, isOverlayPartnerVisible: payload };
        case actions.ACTION_CHOICE_OVERLAY_PARTNER_VISIBLE:
            return { ...state, isActionChoiceOverlayVisible: payload };
        case actions.OVERLAY_ELECTION_VISIBLE:
            return {
                ...state,
                isRockTheVote: payload.isRockTheVote
            };
        case actions.HIDE_NEXT_ACTION_ANIMATION:
            return { ...state, showNextActionAnimation: false };
        case actions.SHOW_NEXT_ACTION_ANIMATION:
            return { ...state, showNextActionAnimation: true };
        case actions.IS_NEXT_ACTION_TRANSITION:
            return { ...state, isNextActionTransition: payload };
        case actions.ACTION_INITIATED_LOCAL_REP:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                lastInitiatedLocalRepIdentifier: payload
            };
        case actions.ACTION_COMPLETED_LOCAL_REP:
            return {
                ...state,
                lastInitiatedLocalRepIdentifier: null
            };
        case actions.WIDGET_VISIBLE:
            return {
                ...state,
                lastActionInitiatedTime: new Date()
            };
        case actions.WIDGET_ENGAGED:
            return {
                ...state,
                engaged: true
            };
        case actions.GO_NEXT_ACTION:
            return {
                ...state,
                activeAction: state.actions.find(
                    a => a.identifier === payload.actionIdentifier
                ),
                showNextActionAnimation: true,
                showLocalRep: false
            };
        case actions.GO_PREV_ACTION:
            return {
                ...state,
                activeAction: state.actions.find(
                    a => a.identifier === payload.actionIdentifier
                ),
                showNextActionAnimation: false,
                showLocalRep: false
            };
        case actions.SET_ACTIVE_ACTION:
            return {
                ...state,
                activeAction: state.actions.find(
                    a => a.identifier === payload.actionIdentifier
                )
            };
        case actions.SET_ACTIVE_ACTION_FROM_ACTION_CHOICE:
            return {
                ...state,
                activeAction: state.actions.find(
                    a => a.identifier === payload.actionIdentifier
                )
            };
        case actions.ON_BACK_FROM_REP_ACTION:
            return {
                ...state,
                showLocalRep: true,
                cancelTime: getTimeFrom(state[`initiatedTime_${payload}`])
            };
        case actions.TWEET_INITIATED:
            return {
                ...state,
                activeAction: state.actions.find(
                    a => a.identifier === payload.actionIdentifier
                )
            };
        case actions.LINK_INITIATED:
            return {
                ...state,
                activeAction: state.actions.find(
                    a => a.identifier === payload.actionIdentifier
                )
            };
        case actions.WIDGET_RESIZED:
            return {
                ...state,
                isMobileResolution: isPortrait()
            };
        case actions.SUBSCRIBE_SUBMITTING:
            return {
                ...state,
                isEmailSubmitting: payload
            };
        case actions.EMAIL_COLLECTED:
            return {
                ...state,
                isEmailSubmitted: payload
            };
        case actions.SHARE_DRAWER_VISIBILITY:
            return {
                ...state,
                shareDrawerVisibility: payload,
                textCopiedToClipboard: false
            };
        case actions.TEXT_COPIED_TO_CLIPBOARD:
            return {
                ...state,
                textCopiedToClipboard: payload
            };
        case actions.SHOW_EMAIL_INTERSTITIAL:
            return {
                ...state,
                showEmailInterstitial: payload
            };
        case actions.INCREMENT_NO_CARDS_VISITED:
            return {
                ...state,
                noCardsVisited: state.noCardsVisited + 1,
                lastActionInitiatedTime: new Date()
            };
        case actions.SET_PARTNER:
            return {
                ...state,
                selectedPartner: partnerFromState(
                    state,
                    payload.actionIdentifier,
                    payload.isFrontCard
                )
            };
        default:
            return defaultState(state);
    }
}
